import { render, staticRenderFns } from "./DataTableCard.vue?vue&type=template&id=26a6c763&scoped=true"
import script from "./DataTableCard.vue?vue&type=script&lang=ts"
export * from "./DataTableCard.vue?vue&type=script&lang=ts"
import style0 from "./DataTableCard.vue?vue&type=style&index=0&id=26a6c763&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a6c763",
  null
  
)

export default component.exports